<div class="block-wrapper" [class.selected]="isSelected">
    <div class="content-wrapper">
        <div fxLayout="row" fxLayoutAlign="space-between center" class="row" >
            <div class="title">
                {{ 'Rest' | translate }}
            </div>
            <div>
                {{ data.data.restTime | durationVerbose:'seconds' }}
            </div>
            <ng-container *ngIf="isEditable">
                <div class="actions">
                    <button mat-icon-button *ngIf="!itsTheFirst"
                            [matTooltip]="'Move_up' | translate"
                            (click)="moveup(data)">
                        <mat-icon>arrow_upward</mat-icon>
                    </button>
                    <button mat-icon-button *ngIf="!itsTheLast"
                            [matTooltip]="'Move_down' | translate"
                            (click)="movedown(data)">
                        <mat-icon>arrow_downward</mat-icon>
                    </button>

                    <button mat-icon-button [matMenuTriggerFor]="menu">
                        <mat-icon>more_vert</mat-icon>
                    </button>
                    <mat-menu #menu="matMenu">
                        <button mat-menu-item
                                [matTooltip]="'Duplicate' | translate"
                                (click)="duplicate(data)">
                            <mat-icon>filter_none</mat-icon>
                            <span>{{ 'Duplicate' | translate}}</span>
                        </button>
                        <button mat-menu-item
                                [matTooltip]="'Delete' | translate"
                                (click)="delete(data)">
                            <mat-icon>delete_outline</mat-icon>
                            <span>{{ 'Delete' | translate}}</span>
                        </button>
                    </mat-menu>
                </div>
            </ng-container>
        </div>
    </div>
    <div class="drag-handle" ngxDragHandle *ngIf="isEditable">
        <mat-icon>drag_indicator</mat-icon>
    </div>
</div>
